<template lang="pug">
el-select(v-model="model")
  el-option(:value="0", :label="$t('low')")
    el-tag(type="info") {{ $t("low") }}
  el-option(:value="1", :label="$t('medium')")
    el-tag(type="warning") {{ $t("medium") }}
  el-option(:value="2", :label="$t('high')") 
    el-tag(type="danger") {{ $t("high") }}
  //- NOTE: only works for multiple
  template(#tag)
    el-tag(:type="model < 1 ? 'info' : model === 1 ? 'warning' : 'danger'") {{ model < 1 ? $t("low") : model === 1 ? $t("medium") : $t("high") }}
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue?: number;
}>();

const emit = defineEmits(["update:modelValue"]);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  },
});
</script>
